import React from 'react';
import { FileText, Plus, Download, Mail, Eye, DollarSign } from 'lucide-react';
export function Invoicing() {
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-1438">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1439">
        <div data-id="element-1440">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1441">
            Manual Invoicing
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1442">
            Bill for custom services like graphic design or consulting.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1443">
          <Plus size={18} data-id="element-1444" />
          Create New Invoice
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1445">
        <div className="lg:col-span-2 bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-8" data-id="element-1446">
          <div className="grid grid-cols-2 gap-8" data-id="element-1447">
            <div className="space-y-2" data-id="element-1448">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1449">
                Client
              </label>
              <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-1450">
                <option data-id="element-1451">Global Tech Solutions</option>
                <option data-id="element-1452">Toronto Creative Hub</option>
                <option data-id="element-1453">New York FinTech</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-1454">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1455">
                Due Date
              </label>
              <input type="date" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1456" />
            </div>
          </div>

          <div className="space-y-4" data-id="element-1457">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1458">Invoice Items</h3>
            <div className="space-y-3" data-id="element-1459">
              <div className="grid grid-cols-12 gap-4 items-center" data-id="element-1460">
                <div className="col-span-7" data-id="element-1461">
                  <input type="text" placeholder="Description" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1462" />
                </div>
                <div className="col-span-2" data-id="element-1463">
                  <input type="number" placeholder="Qty" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1464" />
                </div>
                <div className="col-span-3" data-id="element-1465">
                  <input type="number" placeholder="Price" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1466" />
                </div>
              </div>
            </div>
            <button className="text-xs font-bold text-indigo-600 flex items-center gap-1 hover:underline" data-id="element-1467">
              <Plus size={14} data-id="element-1468" /> Add Item
            </button>
          </div>
        </div>

        <div className="space-y-6" data-id="element-1469">
          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-1470">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1471">
              Branded Preview
            </h3>
            <div className="aspect-[3/4] bg-gray-50 rounded-lg border border-gray-100 p-4 flex flex-col" data-id="element-1472">
              <div className="flex justify-between items-start mb-8" data-id="element-1473">
                <div className="w-12 h-12 bg-indigo-600 rounded flex items-center justify-center text-white font-bold" data-id="element-1474">
                  N
                </div>
                <div className="text-right" data-id="element-1475">
                  <p className="text-[10px] font-bold text-slate-900" data-id="element-1476">
                    INVOICE
                  </p>
                  <p className="text-[8px] text-gray-400" data-id="element-1477">#INV-2023-001</p>
                </div>
              </div>
              <div className="space-y-2 mb-8" data-id="element-1478">
                <div className="h-2 w-24 bg-gray-200 rounded" data-id="element-1479"></div>
                <div className="h-2 w-32 bg-gray-100 rounded" data-id="element-1480"></div>
              </div>
              <div className="flex-1 space-y-3" data-id="element-1481">
                <div className="h-4 w-full bg-white rounded border border-gray-100" data-id="element-1482"></div>
                <div className="h-4 w-full bg-white rounded border border-gray-100" data-id="element-1483"></div>
              </div>
              <div className="pt-4 border-t border-gray-100 flex justify-between" data-id="element-1484">
                <span className="text-[10px] font-bold" data-id="element-1485">Total</span>
                <span className="text-[10px] font-bold text-indigo-600" data-id="element-1486">
                  $0.00
                </span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-1487">
              <button className="flex-1 py-2 bg-gray-50 text-gray-600 rounded-lg text-xs font-bold border border-gray-200 flex items-center justify-center gap-2" data-id="element-1488">
                <Download size={14} data-id="element-1489" /> PDF
              </button>
              <button className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-xs font-bold flex items-center justify-center gap-2" data-id="element-1490">
                <Mail size={14} data-id="element-1491" /> Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}